// components/WhyPMP.jsx
import React, { useState, useEffect } from 'react';
import './WhyPMP.css';
import EligibilityModal from './EligibilityModal';

const WhyPMP = ({ scrollToCalendar, openEligibilityModal }) => {
  const [showEligibilityModal, setShowEligibilityModal] = useState(false);
  const [sectionTitle, setSectionTitle] = useState("");
  const [sectionSubtitle, setSectionSubtitle] = useState("");
  const [values, setValues] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchProjectsExcellenceData();
  }, []);

  const fetchProjectsExcellenceData = async () => {
    try {
      setLoading(true);
      // const response = await fetch('http://localhost/ivtcms/api/rubriques/by-url/Des-projets-menes-a-l-excellence');
      const response = await fetch(`${process.env.REACT_APP_HOTE}api/rubriques/by-url/Des-projets-menes-a-l-excellence`,)
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      
      if (data.success && data.data) {
        const rubriqueData = data.data;
        
        // 1. Récupérer les informations de la rubrique
        setSectionTitle(rubriqueData.titre || "");
        setSectionSubtitle(rubriqueData.descriptif || "");
        
        // 2. Récupérer les articles (valeurs)
        if (rubriqueData.articles && rubriqueData.articles.length > 0) {
          const formattedValues = rubriqueData.articles.map((article) => {
            // Récupérer l'image principale de l'article
            let imageUrl = "";
            let imageAlt = article.titre || "";
            
            if (article.documents && article.documents.length > 0) {
              const firstImage = article.documents.find(doc => 
                doc.type === 'image' || doc.extension?.match(/(jpg|jpeg|png|gif|webp|svg)$/i)
              );
              if (firstImage) {
                imageUrl = firstImage.url;
                imageAlt = firstImage.titre || article.titre;
              }
            }
            
            return {
              id: article.id_article,
              title: article.titre || "",
              description: article.soustitre || "",
              imageUrl: imageUrl,
              imageAlt: imageAlt
            };
          });
          
          setValues(formattedValues);
        } else {
          setValues([]);
        }
      } else {
        throw new Error('Données de rubrique non disponibles');
      }
      
    } catch (err) {
      console.error('Erreur lors de la récupération des données:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleEligibilityComplete = (results) => {
    console.log('Résultats du questionnaire:', results);
    setShowEligibilityModal(false);
    
    // Rediriger vers l'inscription si recommandation PMP
    if (results.recommendation.certification === 'PMP') {
      scrollToCalendar();
    }
  };

  if (loading) {
    return (
      <section className="section why-pmp" id="pourquoi-pmp">
        <div className="contenir">
          {/* Placeholder pour le titre */}
          <div className="loading-placeholder" style={{ 
            height: '50px', 
            width: '70%', 
            marginBottom: '1rem',
            background: '#f0f0f0',
            borderRadius: '4px'
          }}></div>
          
          {/* Placeholder pour le sous-titre */}
          <div className="loading-placeholder" style={{ 
            height: '60px', 
            marginBottom: '2rem',
            background: '#f0f0f0',
            borderRadius: '4px'
          }}></div>

          {/* Placeholder pour les blocs de valeurs */}
          <div className="three-blocks-container">
            {[1, 2, 3].map(i => (
              <div key={i} className="values-block" style={{ background: '#212733' }}>
                <div className="values-icon-container">
                  <div className="values-icon-wrapper">
                    <div className="icon-circle"></div>
                    <div className="values-icon">
                      <div className="loading-placeholder" style={{ 
                        width: '45px', 
                        height: '45px',
                        borderRadius: '50%',
                        background: '#2b3240'
                      }}></div>
                    </div>
                  </div>
                </div>
                
                <div className="loading-placeholder" style={{ 
                  height: '30px', 
                  width: '80%',
                  marginBottom: '1rem',
                  background: '#f5f2ec',
                  borderRadius: '4px'
                }}></div>
                
                <div className="loading-placeholder" style={{ 
                  height: '80px', 
                  background: '#f5f2ec',
                  borderRadius: '4px'
                }}></div>
              </div>
            ))}
          </div>
          
          {/* Deuxième ligne de blocs */}
          <div className="three-blocks-container">
            {[4, 5, 6].map(i => (
              <div key={i} className="values-block" style={{ background: '#212733' }}>
                <div className="values-icon-container">
                  <div className="values-icon-wrapper">
                    <div className="icon-circle"></div>
                    <div className="values-icon">
                      <div className="loading-placeholder" style={{ 
                        width: '45px', 
                        height: '45px',
                        borderRadius: '50%',
                        background: '#2b3240'
                      }}></div>
                    </div>
                  </div>
                </div>
                
                <div className="loading-placeholder" style={{ 
                  height: '30px', 
                  width: '80%',
                  marginBottom: '1rem',
                  background: '#f5f2ec',
                  borderRadius: '4px'
                }}></div>
                
                <div className="loading-placeholder" style={{ 
                  height: '80px', 
                  background: '#f5f2ec',
                  borderRadius: '4px'
                }}></div>
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  }

  if (error) {
    return (
      <section className="section why-pmp" id="pourquoi-pmp">
        <div className="contenir">
          <h2 className="section-title">Des projets menés à l'excellence</h2>
          <p className="section-subtitle" style={{color: '#ff6b6b'}}>
            Erreur de chargement : {error}
          </p>
        </div>
      </section>
    );
  }

  return (
    <section className="section why-pmp" id="pourquoi-pmp">
      <div className="contenir">
        {/* TITRE DYNAMIQUE */}
        <h2 className="section-title">{sectionTitle}</h2>
        <p className="section-subtitle">
          {sectionSubtitle}
        </p>

        {/* PREMIÈRE LIGNE DE BLOCS (3 premiers articles) */}
        {values.length > 0 && (
          <>
            <div className="three-blocks-container">
              {values.slice(0, 3).map((value, index) => (
                <div key={value.id || index} className="values-block confianca-block">
                  <div className="values-icon-container">
                    <div className="values-icon-wrapper">
                      <div className="icon-circle"></div>
                      <div className="values-icon">
                        {value.imageUrl ? (
                          <img 
                            src={value.imageUrl} 
                            alt={value.imageAlt || value.title}
                            onError={(e) => {
                              console.error(`Erreur de chargement de l'image: ${value.title}`, value.imageUrl);
                              e.target.style.display = 'none';
                            }}
                          />
                        ) : (
                          <div style={{ 
                            width: '45px', 
                            height: '45px',
                            backgroundColor: '#94bf3e',
                            borderRadius: '50%'
                          }}></div>
                        )}
                      </div>
                    </div>
                  </div>
                  <h3 className="values-title">{value.title}</h3>
                  <p className="values-description">
                    {value.description}
                  </p>
                </div>
              ))}
            </div>

            {/* DEUXIÈME LIGNE DE BLOCS (3 derniers articles) */}
            <div className="three-blocks-container">
              {values.slice(3, 6).map((value, index) => (
                <div key={value.id || index + 3} className="values-block confianca-block">
                  <div className="values-icon-container">
                    <div className="values-icon-wrapper">
                      <div className="icon-circle"></div>
                      <div className="values-icon">
                        {value.imageUrl ? (
                          <img 
                            src={value.imageUrl} 
                            alt={value.imageAlt || value.title}
                            onError={(e) => {
                              console.error(`Erreur de chargement de l'image: ${value.title}`, value.imageUrl);
                              e.target.style.display = 'none';
                            }}
                          />
                        ) : (
                          <div style={{ 
                            width: '45px', 
                            height: '45px',
                            backgroundColor: '#94bf3e',
                            borderRadius: '50%'
                          }}></div>
                        )}
                      </div>
                    </div>
                  </div>
                  <h3 className="values-title">{value.title}</h3>
                  <p className="values-description">
                    {value.description}
                  </p>
                </div>
              ))}
            </div>
          </>
        )}
      </div>

      <style jsx>{`
        /* Styles pour les trois blocs de valeurs */
        .three-blocks-container {
          display: flex;
          flex-wrap: wrap;
          gap: 2rem;
          margin: 2rem 0;
          justify-content: center;
        }
        
        .values-block {
          flex: 1;
          min-width: 250px;
          padding: 1rem 2.3rem;
          background-color: #212733;
          border-radius: 20px;
          text-align: center;
          display: flex;
          flex-direction: column;
          align-items: center;
          box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);
          border: 1px solid rgba(0, 0, 0, 0.05);
          transition: all 0.3s ease;
          position: relative;
        }
        
        .values-block:hover {
          transform: translateY(-10px);
          box-shadow: 0 15px 40px rgba(0, 0, 0, 0.12);
        }
        
        .values-icon-container {
          margin-bottom: 1.5rem;
          position: relative;
          width: 120px;
          height: 120px;
        }
        
        .values-icon-wrapper {
          position: relative;
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        
        .icon-circle {
          position: absolute;
          width: 80px;
          height: 80px;
          background-color: #f5f2ec;
          border-radius: 50%;
          bottom: 16.5px;
          right: 16.5px;
          z-index: 1;
          opacity: 0.6;
          transition: all 0.3s ease;
        }
        
        .values-icon {
          position: relative;
          z-index: 2;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: #2b3240;
          border-radius: 50%;
          width: 80px;
          height: 80px;
          padding: 15px;
          transition: all 0.3s ease;
        }
        
        .values-icon img {
          width: 45px;
          height: 45px;
          object-fit: contain;
        }
        
        .values-block:hover .values-icon {
          background-color: #2b3240;
        }
        
        .values-block:hover .icon-circle {
          opacity: 0.9;
        }
        
        .values-title {
          font-size: 1.5rem;
          margin-bottom: 1rem;
          color: #f5f2ec;
          font-weight: 700;
          text-transform: uppercase;
          letter-spacing: 1px;
        }
        
        .values-description {
          font-size: 1.05rem;
          line-height: 1.6;
          color: #f5f2ec;
          text-align: center;
          font-weight: 400;
          margin-top: 0.5rem;
        }
        
        /* Styles pour le loading placeholder */
        .loading-placeholder {
          background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
          background-size: 200% 100%;
          animation: loading 1.5s infinite;
        }
        
        @keyframes loading {
          0% { background-position: 200% 0; }
          100% { background-position: -200% 0; }
        }
        
        /* RESPONSIVE */
        @media (max-width: 1024px) {
          .three-blocks-container {
            gap: 2rem;
            margin: 3rem 0;
          }
          
          .values-block {
            min-width: calc(50% - 1rem);
            padding: 2rem;
          }
          
          .values-icon-container {
            width: 110px;
            height: 110px;
          }
          
          .icon-circle {
            width: 80px;
            height: 80px;
          }
          
          .values-icon {
            width: 70px;
            height: 70px;
            padding: 12px;
          }
          
          .values-icon img {
            width: 35px;
            height: 35px;
          }
          
          .values-title {
            font-size: 1.4rem;
          }
          
          .values-description {
            font-size: 1rem;
          }
        }
        
        @media (max-width: 768px) {
          .three-blocks-container {
            gap: 1.5rem;
            margin: 2.5rem 0;
          }
          
          .values-block {
            min-width: 100%;
            padding: 1.8rem;
          }
          
          .values-icon-container {
            width: 100px;
            height: 100px;
          }
          
          .icon-circle {
            width: 70px;
            height: 70px;
          }
          
          .values-icon {
            width: 65px;
            height: 65px;
            padding: 10px;
          }
          
          .values-icon img {
            width: 30px;
            height: 30px;
          }
          
          .values-title {
            font-size: 1.3rem;
          }
          
          .values-description {
            font-size: 0.95rem;
            line-height: 1.5;
          }
        }
        
        @media (max-width: 480px) {
          .three-blocks-container {
            gap: 1rem;
            margin: 2rem 0;
          }
          
          .values-block {
            padding: 1.5rem;
          }
          
          .values-icon-container {
            width: 90px;
            height: 90px;
          }
          
          .icon-circle {
            width: 60px;
            height: 60px;
          }
          
          .values-icon {
            width: 55px;
            height: 55px;
            padding: 8px;
          }
          
          .values-icon img {
            width: 25px;
            height: 25px;
          }
          
          .values-title {
            font-size: 1.2rem;
          }
          
          .values-description {
            font-size: 0.9rem;
            line-height: 1.4;
          }
        }
        
        @media (max-width: 360px) {
          .values-block {
            padding: 1.2rem;
          }
          
          .values-icon-container {
            width: 80px;
            height: 80px;
          }
          
          .icon-circle {
            width: 55px;
            height: 55px;
          }
          
          .values-icon {
            width: 50px;
            height: 50px;
            padding: 6px;
          }
          
          .values-icon img {
            width: 22px;
            height: 22px;
          }
          
          .values-title {
            font-size: 1.1rem;
          }
          
          .values-description {
            font-size: 0.85rem;
          }
        }
      `}</style>
    </section>
  );
};

export default WhyPMP;